import User from './User';

const Users = ({ users, onEdit, userRoles, onResetPassword, onLockUnlock }) => {

    return (<>
        {users && users.map((user, index) => {
            return <User key={user.userId} user={user} index={index} onEdit={onEdit} onResetPassword={onResetPassword} onLockUnlock={onLockUnlock} />
        })}
    </>

    )
}

export default Users
